import React, { useState } from 'react'
import { Alert } from 'react-bootstrap'
import { Subheader } from '../../Page/logix2020/Subheader'
import { useTranslation } from 'react-i18next'
import { GoBackBtn } from '../../Buttons/GoBackBtn'
import { PdfButton } from '../../Buttons/PdfButton'
import DownloadURLAlert from '../../Forms/DownloadURLAlert'
import apiClient from '../../../utils/api/apiClient'
import { APIEndpoints } from '../../../utils/api/apiConfig'
import { useLocalReturnDataState } from '../../../stores/LocalReturnDataProvider'

const StoreReturnSubheader = () => {
  const {
    storingResult
  } = useLocalReturnDataState()
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')
  const [downloadUrl, setDownloadUrl] = useState('')
  const { receiptTransactionNumber } = storingResult

  const loadPdf = () => {
    setError('')
    setIsLoading(true)
    setDownloadUrl('')
    apiClient.postJson(APIEndpoints.localReceiptPrints(receiptTransactionNumber).printStoredReturn, {}, true, true)
      .then(response => {
        const newWindowRef = window.open(response.headers.location)
        if (!newWindowRef) {
          setDownloadUrl(response.headers.location)
        }
      }).catch(() => {
        setError(t('export:createError'));
      }).finally(() => {
        setIsLoading(false)
      })
  }
  return (
    <Subheader className="subHeader-v1">
      <div className="flex-grow-1">
        <div>
          <GoBackBtn color="white" to="/localstorage/returns">
            {t('returnsProcessingPage:overviewReturn')}
          </GoBackBtn>
          <div className="subheader-title-small">{t('returnsProcessingPage:storeReturn')} </div>
        </div>
      </div>
      <PdfButton
            variant="secondary"
            onClick={() => loadPdf()}
            isLoading={isLoading}
            buttonText={t('returnsReceiptOverlayProgress:printStoredReturn')}
            className="subheader__button m-3"
            disabled={!receiptTransactionNumber}
      />
      <div className="w-100">
        {downloadUrl &&
          <DownloadURLAlert
            downloadUrl={downloadUrl}
            setDownloadUrl={setDownloadUrl}
            fileName={t('returnsReceiptOverlayProgress:printStoredReturn')}
          />}
        {error && <Alert variant="danger">{error}</Alert>}
      </div>
    </Subheader>
  )
}

export default StoreReturnSubheader